<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="!showForm">
      <b-col lg="8">
        <b-card >
          <div slot="header">User Role 
            <div class="card-header-actions">
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
          </div>
          <b-row >
            <b-col md="8">
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-2 mr-2">User Name</span></b-input-group-prepend>
                      <b-form-input readonly v-model="tblData.username" placeholder="Select User !" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuUserShow=true">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                    <b-input-group-prepend><span class="p-2">Role Name</span></b-input-group-prepend>
                    <b-form-select v-model="tblData.role_name" :plain="true" :options="userRolesFilt" ></b-form-select>
                  </b-input-group>
            </b-col>
            <b-col md="4">
                  <b-row>
                    <b-button class="btn btn-success ml-3 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
            </b-col>

          </b-row>

          <b-table
            class="mb-0"
            ref="table"
            outlined  responsive hover small
            style="font-size:smaller;" 
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            @row-clicked="rowClicked"
            show-empty
          >
          <template v-slot:cell(nomor)="data">
            {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
          </template>
            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>
              </div>
            </template>
            <template v-slot:cell(empty)="scope">
                  <h4>{{ scope.emptyText }}</h4>
            </template>
            <template v-slot:cell(emptyfiltered)="scope">
                <h4>{{ scope.emptyFilteredText }}</h4>
            </template>
          </b-table>
      <b-row >
        <b-col cols="5">
            <b-row>
              <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries
            </div>
              <b-button size="sm" class="ml-3" @click="showForm=true"  >Add User Role</b-button>                          
            </b-row>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols="4" label="Limit per page"  style="margin-top:0 !important;">
              <b-form-select :options="[10, 15, 20, 25, 30, 40, 50]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="3">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>

      </b-col>
    </b-row>

    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header"> User Role Form </div>
            <b-input-group >
                <b-input-group-prepend><label>UserName</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.username" placeholder="Select User !" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuUserShow=true">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
            </b-input-group>

            <b-row>
            <b-col>
              <b-input-group>
                <b-input-group-prepend
                  ><label>Role Name</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="frmdata.role_name"
                  :plain="true"
                  :options="userRoles"
                  :state="!$v.frmdata.role_name.$error"
                ></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>


    <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of Users" :centered="true">
        <lku-user @click="onSelectUser"></lku-user>
    </b-modal>        
  </div>
</template>


<script>
import toastr from "mini-toastr";
import lkuUser from "../lookup/lkuUser";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuUser},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        user_id: { required },
        role_name: { required },
    },
  }, 
  data() {
    return {
      showForm: false,
      showDelConfirm: false,
      lkuUserShow:false,
      lkuCompanyShow:false,
      frmdata:{user_id: '', username: '', role_name:'' },
      userRoles:[],userRolesFilt:[],
      tblData: {
        tablename:'user-roles',
        page: 1,
        total: 0,
        limit:10,
        sortBy: 'username',
        sortDesc: false, customQuery:''
      },
      tblFields: [
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "username",
            label: "User Name",
            sortable: true
          },
          {
            key: "role_info",
            label: "Role Name",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
      ],

      list:[],
    };
  },
  computed: {    
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  // watch: {  
  //   user_id: function (newval) {
  //     if (newval) {
  //         this.tblData.customQuery=`user_id=${newval}`;
  //     } else {
  //         this.tblData.customQuery='';
  //     }
  //   }
  // },
created: async function () {
      const [userRoles] = await Promise.all([
        crud.list({
          tablename: "rolename",
          page: 1,
          limit: 10000,
          total: 0,
          sortBy: "role_info",
          sortDesc: false,
        })
      ]);
      userRoles.forEach((tp) => {
        this.userRoles.push({ value: tp.role_name, text: tp.role_info });
        this.userRolesFilt.push({ value: tp.role_name, text: tp.role_info });
      });

  },  
  methods: {
    onSelectUser(_selected) {
        this.tblData.username = _selected.username;
        this.tblData.user_id = _selected.user_id;
        this.frmdata.username = _selected.username;
        this.frmdata.user_id = _selected.user_id;
        this.lkuUserShow=false;
        // this.refresh();
    },
    data: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let  customQuery ='';
      if (this.tblData.user_id) {
        customQuery += customQuery ? '&' : '';
          customQuery +=`user_id=${this.tblData.user_id}`;
      } 
      if (this.tblData.role_name) {
        customQuery += customQuery ? '&' : '';
          customQuery +=`role_name=${this.tblData.role_name}`;
      } 
      this.tblData.customQuery= customQuery ;
      
      const list = await crud.list(this.tblData);    
      // console.log(list) ;
      this.list=list; 
      return this.list;
    },
    search() {
      this.tblData.page=1;
      if (this.$refs.table) this.$refs.table.refresh();
    },
    refresh() {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter() {
        this.filter.username= '';
        this.filter.user_id='';
        this.filter.role_name='';
        this.refresh();
    },

    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'user-roles', key:this.model._id});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              const invalidobj={};
              for (var key in this.$v.frmdata) {
                if (this.$v.frmdata[key].$anyError) {
                  if (this.$v.frmdata[key].$anyError==true) invalidobj[key] = this.$v.frmdata[key];
                }
              }        
              console.log('validation model: ', this.frmdata);
              console.log('validation field: ', invalidobj);
              toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
            try {
                await crud.insert(
                  { tablename:'user-roles',                      
                     data:{
                       user_id:this.frmdata.user_id,
                       role_name:this.frmdata.role_name,
                     }
                  });
              toastr.success(`Saved Successfully`, "Content Category", 10000);

              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
              console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                } 
            }
        }
    },  
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
